import { providerConfig } from '../config/providers'
import type { MobilityProvider, RideRequest } from './MobilityProvider'
import { buildUberDeepLink } from './uberDeepLink'

export class UberProvider implements MobilityProvider {
  readonly name = 'UberProvider'

  buildRideUrl(request: RideRequest): string {
    return buildUberDeepLink(providerConfig.mobility.uber, request)
  }

  openRideRequest(request: RideRequest): void {
    const url = this.buildRideUrl(request)
    window.location.assign(url)
  }
}
